//import './modules/owl.carousel/owl.carousel.min.js';
import './modules/fancybox/jquery.fancybox.min.js';
import './modules/jquery.selectric.min.js';
import './modules/conditionize.jquery.js';
import AOS from 'aos';
import EmblaCarousel from 'embla-carousel';
import Accessibility from 'embla-carousel-accessibility';
import { addDotButtonAndClickHandlers } from './modules/emblaDots.js';
import { addPrevNextButtonClickHandlers } from './modules/emblaArrows.js';
import { addAccessibility } from './modules/emblaAccessibility.js';
import { addCenterWhenFits } from './modules/emblaCenter.js';
import Fade from './modules/emblaFadeOut.js';


const sentinel = document.getElementById('header-sentinel');
const header = document.getElementById('header');

const observer = new IntersectionObserver(
  ([entry]) => {
    header.classList.toggle('is-stuck', !entry.isIntersecting);
  },
  { threshold: [0] }
);

observer.observe(sentinel);

AOS.init({
	duration: 900,
	offset: 90,
	once: true
});



function initAttorneyCarousel($) {
	var $attorneyCarousel = $('.attorney-spotlight');

	if (!$attorneyCarousel.length || typeof themeData === 'undefined') {
		return;
	}

	function setupEmbla($el) {


		const OPTIONS = { loop: true }

		const emblaNode = $el[0]
		const viewportNode = emblaNode.querySelector('.embla__viewport')
		const prevBtn = emblaNode.querySelector('.embla__button--prev')
		const nextBtn = emblaNode.querySelector('.embla__button--next')
		const dotsNodes = emblaNode.querySelectorAll('.embla__dots')

		const emblaApi = EmblaCarousel(viewportNode, OPTIONS, [Fade()]);

		addDotButtonAndClickHandlers(emblaApi, dotsNodes);

	}

	// The _ param busts any cache that ignores Cache-Control
	$.getJSON(themeData.randomAttorneysUrl, { _: Date.now() })
		.done(function (res) {
			if (!res.html) {
				return;
			}

			$attorneyCarousel.find('.embla__container').html(res.html);
			setupEmbla($attorneyCarousel);
		})
		.always(function () {
			$attorneyCarousel.removeClass('is-loading');
		});
}


function initServicesCarousel() {
	if (typeof EmblaCarousel === 'undefined') {
		return;
	}

	// Support more than one carousel on the page
	document.querySelectorAll('.services-carousel-band .embla').forEach(function (emblaNode) {
		const viewportNode = emblaNode.querySelector('.embla__viewport');
		const prevBtn = emblaNode.querySelector('.embla__button--prev');
		const nextBtn = emblaNode.querySelector('.embla__button--next');

		if (!viewportNode) {
			return;
		}

		const emblaApi = EmblaCarousel(viewportNode, {
			dragFree: true,
			align: 'start',
		}, [
		  Accessibility({
		    announceChanges: true,
		    rootNode: (emblaRoot) => emblaRoot.parentElement
		  })
		]);
		addPrevNextButtonClickHandlers(emblaApi, prevBtn, nextBtn);
		addCenterWhenFits(emblaApi);
		addAccessibility(emblaApi);
	});
}

jQuery(function ($) {

	initAttorneyCarousel($);
	initServicesCarousel();

	// Homepage: Random hero animation items
	var $homeAnimationItems = $('.home-hero-content .animation-wrap');
	if ($homeAnimationItems.length) {
		var randomIndex = Math.floor(Math.random() * $homeAnimationItems.length);
		$homeAnimationItems.eq(randomIndex).css('visibility', 'visible');
	}

	// Expand/collapse header search form
	const $header = $('#header');
	const $headerSearchForm = $('#header .search-form');
	const $headerSearchInput = $('#header .search-input');
	const $headerSearchButton = $('#header .search-submit');

	const openSearch = () => {
		$header.addClass('is-search-open');
		$headerSearchButton.attr('aria-expanded', 'true');
		$headerSearchInput.trigger('focus');
	};

	const closeSearch = () => {
		$header.removeClass('is-search-open');
		$headerSearchButton.attr('aria-expanded', 'false');
	};

	$headerSearchForm.on('submit', function (e) {
		const isOpen = $header.hasClass('is-search-open');
		const hasValue = $.trim($headerSearchInput.val()) !== '';

		if (!isOpen) {
			e.preventDefault();
			openSearch();
		} else if (!hasValue) {
			e.preventDefault();
			closeSearch();
		}
	});

	$(document).on('click', function (e) {
		if ($(e.target).closest($headerSearchForm).length) return;
		closeSearch();
	});

	/* Get viewport dimensions */
	let vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
	let vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);

	/* --- Get window width to check for resize --- */
	/* See: http://stackoverflow.com/questions/17328742/mobile-chrome-fires-resize-event-on-scroll */
	var originalWindowWidth = $(window).width();


    /* --- Fancybox --- */
    jQuery("[data-fancybox]").fancybox({
        iframe : {
            css : {
                width : '500px',
                height : '230px'
            }
        }
    });


	/* --- "Select" field styles --- */
	$('select').selectric({
		maxHeight: 250,
		disableOnMobile: false,
		arrowButtonMarkup: '<i class="sel-btn fa-solid fa-chevron-down" aria-hidden="true"></i>',
	});

	/* --- Accordion Widget (on the Blog & Single post) --- */
	$('#main').on('click', '.accordion-widget-title a', function(){
		$(this).find('.icon').toggleClass('icon-plus icon-minus');
		$(this).closest('.accordion-widget').find('ul').slideToggle(250);
		return false;
	});


	/* -- For Phone -- */
	$('#main').on('click', '.tab-button-mobile', function(){

		var target = $(this).attr('href');
		target = target.replace('#', '');
		target = '#tab-'+target;

		if(!$(this).hasClass('active-tab-button-mobile')){
			//$('.tab-content').not(target).slideUp(300);
			$('.tab-content').not(target).hide();
			$('.tab-button-mobile').not($(this)).removeClass('active-tab-button-mobile').find('.icon').addClass('icon-plus').removeClass('icon-minus');
			$(this).addClass('active-tab-button-mobile');
			$(this).find('.icon').toggleClass('icon-minus icon-plus');
			$(target).stop().slideDown(300);
			$('html, body').animate({
				scrollTop: $(this).offset().top
			}, 400);
		} else {
			$(this).removeClass('active-tab-button-mobile');
			$(this).find('.icon').toggleClass('icon-minus icon-plus');
			$(target).slideUp(300);
		}
	});


	/* --- Attorney Photo Slider --- */
	// $('#attorney-photo-slider').imagesLoaded( function() {

		// var owl = $('#attorney-photo-slider');
		// owl.owlCarousel({
			// loop:true,
			// center:true,
			// autoplay:false,
			// autoplayTimeout:5000,
			// autoPlayHoverPause:true,
			// items:8,
			// nav:true,
			// autoWidth: true,
			// navContainer:'#attorney-photo-slider-controls',
			// navText: [
				// "<i class='icon icon-left-open'>",
				// "<i class='icon icon-right-open'>"
			// ],
			// responsive : {
				// // breakpoint from 0 up
				// 0 : {
					// autoplay: true
				// },
				// // breakpoint from 500 up
				// 500 : {
					// autoplay: false
				// },
			// }
		// });

	// });


	/* --- Disable Office Google Map scroll wheel zoom on mobile */
	if( $('#show-menu').is(':visible') ){
		$('#office_map').addClass('scrolloff');                // set the mouse events to none when doc is ready

		$('#office_map_overlay').on("mouseup",function(){          // lock it when mouse up
			$('#office_map').addClass('scrolloff');
			//somehow the mouseup event doesn't get called...
		});
		$('#office_map_overlay').on("mousedown",function(){        // when mouse down, set the mouse events free
			$('#office_map').removeClass('scrolloff');
		});

		$("#office_map").mouseleave(function () {              // becuase the mouse up doesn't work...
			$('#office_map').addClass('scrolloff');            // set the pointer events to none when mouse leaves the map area
														// or you can do it on some other event
		});
	}

	/* --- Responsive Header --- */
	// Hide/show mobile menu button
	$('#show-menu').on('click', function () {
		$('#header').toggleClass('mobile-menu-expanded');
		$('#header-content').slideToggle(200);
		return false;
	});

	// Expand/collapse button
	$('.sub-nav-toggle').click( function() {
			$(this).find('i').toggleClass('fa-plus fa-minus');
			$(this).next('.sub-menu-wrap').slideToggle(200);
			return false;
	});


	/* --- Responsive Side Nav Dropdown --- */
	if($('.sidebar-left .side-menu li').length){
		$('.sidebar-left .side-menu').clone().prependTo('.main-content').addClass('mobile-side-menu');
		$('.main-content .side-menu ul').removeAttr('id');
	}
	$('.mobile-side-menu li li.current-menu-item, .main-content .side-menu > ul > li.current-page-ancestor:not(.current-menu-ancestor) li:first-child, .mobile-side-menu > ul > li.current-page-ancestor:not(.current-menu-ancestor) li:first-child, .mobile-side-menu > ul > li.current-menu-item li:first-child').click(function(event){
		var $subMenu = $(this).closest('.sub-menu');
		if( ! $subMenu.hasClass('active') ){
			event.preventDefault();
			$(this).siblings().show();
			$subMenu.addClass('active');
		}
	});

	$('.mobile-side-menu li').click(function(event){
		event.stopPropagation();
	});

	// Close when clicked away
	$(window).click(function() {
		// Hide the menu if visible
		$('.mobile-side-menu li').removeAttr('style');
		$('.mobile-side-menu .sub-menu').removeClass('active');
	});


	$('.sh-right-square .enews-button-link').clone().appendTo('.main-area');


	// -- Convert Footer Form Label into placeholder
	 $("#footer form .e2ma_signup_form_row").each(function(index, elem) {
		 var label = $(elem).find('.e2ma_signup_form_label').text();
		 if(label) {
			 label = label.replace(/[\t\n]+/g,' ');
			 label = $.trim(label.replace(/ +(?= )/g,''));
			 $(elem).find('input[type="text"], input[type="email"]').attr({
				placeholder: label,
				'aria-label': label
			});
			 $(elem).find('.e2ma_signup_form_label').remove();
		 }
	 });

	$('#footer #e2ma_signup_submit_button').replaceWith(function () {
		return $('<button>', {
			id: this.id,
			class: 'e2ma_signup_form_button btn',
			type: 'submit',
			name: this.name,
			text: 'Subscribe',
			disabled: this.disabled
		});
	});


	// Open Emma form in footer in new tab/window
	$('body').on('click', '#e2ma_signup_submit_button', function(event) {
		event.preventDefault();
		$(this).closest('form').attr('target', '_blank').submit();
	});

	// Tab Nav

	function updateMobileTabNavBtn() {
		let $activeTab = $('.nav-tabs li a.active');
		if ($activeTab.length) {
			$('.tab-nav-toggle .button-text').text($activeTab.text());
		}
	}
	updateMobileTabNavBtn();
	$('.nav-tabs li a').on('click', function () {
		$('.nav-tabs li a').removeClass('active');
		$(this).addClass('active');
		updateMobileTabNavBtn();
	});
	$('.tab-nav-toggle').on('click', function () {
		$(this).toggleClass('expanded');
		$('.nav-tabs').slideToggle(200);
	});
	$(document).on('click', function (e) {
		var $target = $(e.target);
		if ($target.closest($('.tab-nav-toggle')).length) {
			return;
		}
		$('.nav-tabs').slideUp(200);
		$('.tab-nav-toggle').removeClass('expanded');
	});


	jQuery('.conditional').conditionize();
});
